module.exports = __webpack_public_path__ + "img/logo.85ce9b5c.png";